<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import Text from '../../common/components/Text.svelte';
  const { productDetails, pageTemplate } = getAppConfig();
  const isUpgrade = pageTemplate === 'extraPreOrderLandingPageTemplate' && productDetails?.upgradeDisclaimerText;
  console.log(isUpgrade, pageTemplate, productDetails?.upgradeDisclaimerText, ' productDetails?.upgradeDisclaimerText');
</script>

{#if isUpgrade}
  <div class="position-relative d-flex justify-content-center ms-auto fw-bold text-uppercase upgrade-text">
    <Text key="extra.preorder.upgrade" />
  </div>
{/if}
